import React, { useState, useEffect, Fragment } from 'react';
import { toast } from 'react-toastify';
import Breadcrumb from '../common/breadcrumb';
import axios from 'axios';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faToggleOn, faToggleOff } from '@fortawesome/free-solid-svg-icons';

import '../../assets/scss/app-styles/users.scss';

const UaAgent = () => {

    const [style, setStyle] = useState('custom-spinner');
    const [active, setActive] = useState(false);
    const [value, setValue] = useState('');

    const cloudId = JSON.parse(localStorage.getItem('creds')).cloud_id;

    const headers = {
        headers: {
            Token: localStorage.getItem("token"),
        }
    };

    useEffect(() => {
        const creds = JSON.parse(localStorage.getItem('creds'));
        const cloud_id = creds.cloud_id;
        const reqHeaders = { headers: { Token: localStorage.getItem("token") } };
        const payLoad = { cloud_id };

        axios.post(`${process.env.REACT_APP_API_URL}getUaAgent`, payLoad, reqHeaders)
            .then(response => {
                const agent = response.data;
                if (agent && agent !== "") {
                    setActive(true);
                    setValue(agent);
                } else {
                    setActive(false);
                    setValue('');
                }
                setStyle('custom-spinner-hide');
            })
            .catch(err => {
                toast.error(err.message);
                setStyle('custom-spinner-hide');
            });
    }, []);

    const handleSave = () => {
        if (active && (!value || value.trim() === '')) {
            toast.error("Value is mandatory.");
            return;
        }

        const payLoad = {
            cloud_id: cloudId,
            active: active,
            ...(active && { value: value.trim() }),
        };

        setStyle('custom-spinner');

        axios.post(`${process.env.REACT_APP_API_URL}updateUaAgent`, payLoad, headers)
            .then(response => {
                toast.success(response.data || "Saved successfully.");
                setStyle('custom-spinner-hide');
            })
            .catch(err => {
                toast.error(err.message);
                setStyle('custom-spinner-hide');
            });
    };

    return (
        <Fragment>
            <Breadcrumb parent="App" title="UA Accept Agent Security" />

            <div className={"loader-box " + style}>
                <div className="loader">
                    <div className="line bg-primary"></div>
                    <div className="line bg-primary"></div>
                    <div className="line bg-primary"></div>
                    <div className="line bg-primary"></div>
                </div>
            </div>

            <div className="container-fluid main-container">
                <Card className="col-md-12 col-sm-12 ua-agent-card">
                    <CardHeader>
                        <h5>UA Accept Agent Security</h5>
                    </CardHeader>
                    <CardBody>

                        <div className="form-group">
                            <label className="d-block font-weight-bold mb-1">
                                {active ? "Enabled" : "Disabled"}
                            </label>
                            <FontAwesomeIcon
                                icon={active ? faToggleOn : faToggleOff}
                                className="icon-check"
                                style={{
                                    fontSize: "32px",
                                    cursor: "pointer",
                                    color: active ? "green" : "red",
                                }}
                                title={active ? "Enabled. Click to Disable." : "Disabled. Click to Enable."}
                                onClick={() => {
                                    setActive(prev => {
                                        if (prev) setValue('');
                                        return !prev;
                                    });
                                }}
                            />
                        </div>

                        <p className="ua-agent-disclaimer">
                            Enabling the UA Accept Agent will restrict SIP registrations to only those matching the specified
                            agent string. Ensure the value is accurate before saving, as an incorrect entry may prevent
                            devices from registering.
                        </p>

                        <div className="form-group">
                            <label htmlFor="acceptAgent">Accept Agent</label>
                            <input
                                id="acceptAgent"
                                type="text"
                                className="form-control"
                                placeholder="Enter accept agent value"
                                value={value}
                                onChange={e => setValue(e.target.value)}
                                disabled={!active}
                            />
                        </div>

                        <button
                            className="btn btn-primary mt-2"
                            onClick={handleSave}
                        >
                            Save
                        </button>

                    </CardBody>
                </Card>
            </div>

        </Fragment>
    );
};

export default UaAgent;
